import { cn } from "@/domains/library"

export const ScaleCard400 = ({
  children,
  className,
  onClick,
  style,
}: {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    if (onClick) {
      onClick(event)
    }
  }
  return (
    <div
      className={cn(
        "sc-card-400",
        "bg-p400",
        "border-p300-shade rounded-lg border",
        "transition-all duration-300 ease-in-out",
        className,
      )}
      onClick={handleClick}
      style={style}
    >
      {children}
    </div>
  )
}
